import { Api } from "../uikit/service/api";
import { isAuth } from "../uikit/login";
import { editorActions } from "../store/editor";
import { get, isEmpty } from "lodash";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function useSaveSubscriber() {
  const api = new Api(false);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const setSubscriberParamsData = val => {
    dispatch(editorActions.setSubscriberParamsData(val));
  };

  const getSubscriberParamsData = async () => {
    const id = searchParams.get("q") || "";
    const res = await api.getWithError(`/api/studios/${id}`);
    const data = res?.data || {};
    if (isEmpty(data)) {
      return;
    }
    data.attributes.guest_user_key = data.guest_user_key;
    data.attributes.imagica_byod = data.imagica_byod;
    setSubscriberParamsData(data);
    return data;
  };

  const setSubscriberParamsByQ = async id => {
    if (isEmpty(id)) {
      return;
    }
    const res = await api.getWithError(`/api/studios/${id}`);
    const data = res?.data || {};
    data.attributes.guest_user_key = data.guest_user_key;
    setSubscriberParamsData(data);

    return data;
  };

  return {
    getSubscriberParamsData,
    setSubscriberParamsByQ,
  };
}
